import { Lohnart } from '../../contracts/enums/Lohnart.js';
import { allSalaryTableLevels, type SalaryTableLevels } from '../../salary-table/enum/SalaryTableLevels.js';
import { allSalaryTableRowKeys, type SalaryTableRowKeys } from '../../salary-table/enum/SalaryTableRowKeys.js';
import { getSalaryTable } from '../../salary-table/server/getSalaryTable.js';

export function getLodasNumberForLohnart(lohnart: Lohnart): number {
  let lohnArtIndex = 3000;
  for (const curLohnart of Object.values(Lohnart)) {
    if (curLohnart === lohnart) return lohnArtIndex;
    lohnArtIndex++;
  }

  throw new Error('Lohnart not found');
}

export async function generateLohnartLodasData(satzNummer: string) {
  const mappedLine: string[] = [];
  const salaryTable = await getSalaryTable();

  for (const tarifgruppe of allSalaryTableRowKeys()) {
    const salarayLine = salaryTable[tarifgruppe].levels;
    if (!salarayLine) continue;

    allSalaryTableLevels().forEach((curLevel, levelIndex) => {
      const inc = getIncrement(tarifgruppe, curLevel);
      mappedLine.push(`${satzNummer};${inc.toString()};Entg. ${tarifgruppe}/${levelIndex + 1};200`);
    });
  }

  let lohnArtIndex = 3000;
  for (const lohnart of Object.values(Lohnart)) {
    mappedLine.push(`${satzNummer};${lohnArtIndex};${lohnart};200`);
    lohnArtIndex++;
  }

  return mappedLine.join('\r\n');
}

export function getIncrement(tarifgruppe: SalaryTableRowKeys, index: SalaryTableLevels) {
  let inc = 2000;

  const keys = allSalaryTableRowKeys();
  const indexOfKey = keys.findIndex(k => k === tarifgruppe);
  if (indexOfKey === -1) return 0;
  return inc + index + 6 * indexOfKey;
}
